import React, { MouseEvent, ReactNode, useState } from 'react';

import { NavLink } from '~/lib/react-router-dom';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';

interface NavDropdownItem {
  href: string;
  label: string;
  icon?: ReactNode;
}

interface NavDropdownProps {
  buttonLabel: string;
  items: Array<NavDropdownItem>;
}

export default function NavDropdown({ buttonLabel, items }: NavDropdownProps) {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorElement);

  const openMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorElement(null);
  };

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <Button color="inherit" endIcon={<KeyboardArrowDownIcon />} onClick={openMenu} sx={{ textTransform: 'none' }}>
        {buttonLabel}
      </Button>

      <Menu open={isOpen} anchorEl={anchorElement} onClose={closeMenu}>
        {items.map((item) => (
          <MenuItem key={`${item.href}-${item.label}`} onClick={closeMenu} to={item.href} component={NavLink}>
            {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
